import { Button, Card, CardActions, CardContent, LinearProgress, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { commons } from '../../commons';
import { formToObj, validateFormData } from '../../lib/validator';
import AuthService from '../../service/AuthService';
import { customStyles } from "../../styles/tableStyle"
import { project } from '../../schema/formSchema/project';
import { FormGenerator } from '../../lib';
import { appMessages } from '../../constants/appMessages';
import { SnackBarWidget } from '../../Widget';

function Project(props) {
  const [projectData, setProjectData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    loadForm()
  }, []);



  const loadForm = async () => {
    let projectSchemaData = [...project];
    if (props.project) {
      projectSchemaData.map((item, index) => {
        projectSchemaData[index].value = props.project[item.key]
      })
    }
    setProjectData(projectSchemaData);
  };

  const loadDefaults = () => {
    setStatus(false)
    setMessage('')
    props.closeDialog()
  }

  const onSubmitProject = async (event) => {
    event.preventDefault();
    let projectContent = [...projectData];
    let validFormData = await validateFormData(projectContent);
    setProjectData(validFormData)
    let result = validFormData.find(item => {
      if (item.error.length) return item;
    });


    if (!result) {
      setLoading(true)
      let params = await formToObj(validFormData);
      params.op = props.project ? "setProject" : "createProject"
      if (props.project) params._id = props.project._id["$oid"]
      commons.getAPIRes(params, "POST", "project").then(userRes => {
        setLoading(false)
        setStatus(userRes.status)
        if (userRes.status) {
          setMessage(props.project ? appMessages.setProjSucMsg : appMessages.createProjSucMsg)
          props.reloadPage()
        }
        else
          setMessage(props.project ? appMessages.setProjFailMsg : appMessages.createProjFailMsg)
        setTimeout(function () {
          loadDefaults()
        }.bind(this), 2000)
      });
    }

  };

  const handleChange = e => {
    let formDataInput = [...projectData];
    formDataInput.find(item => {
      if (item.key === e.target.name) {
        item.value = item.type === "number" ? parseInt(e.target.value) : e.target.value;
      }
    });
    setProjectData(formDataInput)
  };


  return (
    <Card>
      {loading ? <LinearProgress /> : false}
      <CardContent style={{ justifyContent: 'center' }}>
        <FormGenerator
          formList={projectData}
          editMode={true}
          onChange={handleChange}
        />

      </CardContent>
      <CardActions style={{ justifyContent: 'end' }}>
        <Button onClick={props.closeDialog} disabled={loading} style={{ ...customStyles.submitBtn }} >Cancel </Button>
        <Button onClick={onSubmitProject} disabled={loading} style={{ ...customStyles.submitBtn }} > Submit </Button>
      </CardActions>
      <SnackBarWidget status={status} message={message} />
    </Card>
  );
}

export default Project;
